/**
 * @param {String} name
 * @param {*} value
 * @param {*} config
 */
export function setCookie(name, value, config = {}) {
    const options = {
        domain: getCookiesDomain(),
        path: '/',
        ...config,
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    document.cookie = Object.entries(options).reduce(
        (cookie, [key, option]) =>
            option !== true ? `${cookie}; ${key}=${option}` : `${cookie}; ${key}`,
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    );
}

/**
 * @param {String} name
 */
export function getCookie(name) {
    if (!checkCookiesEnabled()) return undefined;

    const regExp = new RegExp(
        `(?:^|; )(${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}.*?)=([^;]*)`, // eslint-disable-line
    );
    const matches = document.cookie.match(regExp);

    return matches ? decodeURIComponent(matches[2]) : undefined;
}

/**
 *
 * @param {String} name
 */
export function deleteCookie(name) {
    setCookie(name, '', { 'max-age': -1 });
}

export function getCookiesDomain() {
    return window.location.hostname.split('.').slice(-2).join('.');
}

export function checkCookiesEnabled() {
    let cookiesEnabled = navigator.cookieEnabled;

    if (!cookiesEnabled) {
        document.cookie = 'test_cookie';
        cookiesEnabled = document.cookie.indexOf('test_cookie') !== -1;
        deleteCookie('test_cookie');
    }

    return cookiesEnabled;
}

/**
 * Special comma-separated flags that we use to set during automation runs.
 *
 * Flags may disable some UI features:
 *
 *  -notification-banner : hide portal notification from header
 *
 *  -billing-banner      : completelly remove billing banner MFE
 */
export function getAQAModeFlags() {
    try {
        const flags = getCookie('__ENABLE_AQA_MODE__');
        return flags || '';
    } catch {
        return '';
    }
}
